import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTier } from "./tierContext";
import type { TierLevel } from "../types/UserTypes";

const TIER_ORDER: Record<TierLevel, number> = {
  free_crew: 0,
  core: 1,
  pro: 2,
  enterprise: 3,
};

interface RequireTierProps {
  minTier: TierLevel;
  children: React.ReactNode;
  redirectTo?: string;
}

export default function RequireTier({
  minTier,
  children,
  redirectTo = "/settings/billing",
}: RequireTierProps) {
  const { tier, loading } = useTier();
  const location = useLocation();

  if (loading) return null;

  const currentRank = TIER_ORDER[tier] ?? 0;
  const requiredRank = TIER_ORDER[minTier] ?? 0;

  if (currentRank < requiredRank) {
    if (location.pathname === redirectTo) {
      return (
        <div style={{ padding: 16 }}>
          <h3>Upgrade Required</h3>
          <p>
            This feature requires the{" "}
            <strong>{minTier.replace("_", " ")}</strong> plan or higher.
          </p>
        </div>
      );
    }
    return (
      <Navigate to={redirectTo} replace state={{ from: location.pathname }} />
    );
  }

  return <>{children}</>;
}
